import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import { IntlProvider } from 'react-intl';
import { systemLanguage, systemMessages } from './locale/index'

ReactDOM.render(
    <React.StrictMode>
        <IntlProvider locale={systemLanguage} messages={systemMessages}>
            <App />
        </IntlProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();